import * as React from "react";
import { forwardRef } from "react";
const SvgIcTurret32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M22 11H17.5V23H15.5V11H11V9H22V11Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcTurret32);
export { ForwardRef as ReactComponent };
